
import HeroSection from './components/HeroSection';
import ContactForm from './components/ContactForm';
import LocationMap from './components/LocationMap';

export default function Contact() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ContactForm />
      <LocationMap />
    </div>
  );
}
